import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";

const selectSelf = (state: RootState) => state;
const selectLead = createSelector(selectSelf, (state) => state.lead);

export const selectIsLeadLoading = createSelector(
  selectLead,
  (lead) => lead.isLoading
);

export const selectLeads = createSelector(
  selectLead,
  (lead) => lead.leads
);

export const selectLeadIds = createSelector(
  selectLead,
  (lead) => lead.leadIds
);

export const selectLeadDetails = createSelector(
  selectLead,
  (lead) => lead.leadDetail
);


